import type { TranslateFn } from '@/shared/types';

/** Translates a backend auth message key, falling back to `fallbackKey` when it's missing or unknown. */
export function translateAuthMessage(
    t: TranslateFn,
    message: string | undefined,
    fallbackKey: string,
    options?: Record<string, unknown>,
): string {
    if (!message) {
        return t(fallbackKey, options);
    }

    return t(message, { ...options, defaultValue: t(fallbackKey, options) });
}
